import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { School } from 'lucide-react';
import { LoginForm } from '@/components/auth/LoginForm';
import { supabase } from '@/lib/supabase';

export default function LoginPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          navigate('/admin', { replace: true });
        }
      } catch (error: any) {
        console.error('Session check error:', error);
      }
    };
    checkSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gradient-to-b from-blue-50 to-blue-100">
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center">
          <School className="h-12 w-12 text-primary" />
          <h1 className="mt-4 text-3xl font-bold">Teacher Reporter</h1>
          <p className="mt-2 text-muted-foreground">
            Sign in to access your dashboard
          </p>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-lg space-y-6">
          <LoginForm />
        </div>
      </div>
    </div>
  );
}